import { useState } from "react";
import { X, CheckCircle2 } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";

const REASONS = ["resolved", "not_an_issue", "accepted_risk", "duplicate", "other"];
const REASONS_REQUIRING_NOTE = ["not_an_issue", "accepted_risk", "other"];

export default function WarningCloseForm({ warningId, onClose, onSubmit, busy }) {
  const { t } = useT();
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState("");

  const noteRequired = reason && REASONS_REQUIRING_NOTE.includes(reason);

  const submit = () => {
    if (!reason) return;
    if (noteRequired && !note.trim()) return;
    onSubmit({ reason, note: note.trim() || undefined });
  };

  return (
    <div className="mt-3 rounded-lg border border-slate-200 bg-white p-3" data-testid={`warning-close-form-${warningId}-wrap`}>
      <div className="text-xs font-semibold text-slate-700 mb-2">{t("warnings.close.title")}</div>
      <div className="flex flex-wrap gap-2">
        {REASONS.map((r) => (
          <button
            key={r}
            data-testid={`warning-close-reason-${warningId}-${r}`}
            onClick={() => setReason(r)}
            className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full border text-sm transition ${
              reason === r
                ? "bg-[#1B4332] border-[#1B4332] text-white"
                : "bg-white border-slate-300 text-slate-700 hover:bg-slate-50"
            }`}
          >
            {reason === r && <CheckCircle2 className="w-3.5 h-3.5" />}
            {t(`warnings.close.reason.${r}`)}
          </button>
        ))}
      </div>

      {reason && (
        <div className="mt-3">
          <textarea
            data-testid={`warning-close-note-${warningId}`}
            rows={2}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={noteRequired ? t("warnings.close.note_required_placeholder") : t("warnings.close.note_optional_placeholder")}
            className="w-full text-sm rounded-md border border-slate-300 p-2"
          />
          {noteRequired && (
            <div className="text-xs text-amber-700 mt-1">{t("warnings.close.note_required")}</div>
          )}
        </div>
      )}

      <div className="flex justify-end gap-2 mt-3">
        <button
          data-testid={`warning-close-cancel-${warningId}`}
          onClick={onClose}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-sm hover:bg-slate-100 text-slate-700"
        >
          <X className="w-3.5 h-3.5" /> {t("btn.cancel")}
        </button>
        <button
          data-testid={`warning-close-submit-${warningId}`}
          onClick={submit}
          disabled={busy || !reason || (noteRequired && !note.trim())}
          className="px-3 py-1.5 rounded-md text-sm bg-[#1B4332] text-white hover:opacity-90 disabled:opacity-60"
        >
          {t("warnings.close.submit")}
        </button>
      </div>
    </div>
  );
}
